export default __webpack_public_path__ + "static/media/badges-bg.95938eb6.jpg";